import React, { Component } from 'react';
import { ConceptExplanation, ConceptSelector, } from '../../index';

class ChooseModelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedConceptUID: props.modelConceptUID
    };
  }

  componentDidUpdate(prevProps) {
    // Update state when modelConceptUID prop changes
    if (prevProps.modelConceptUID !== this.props.modelConceptUID) {
      this.setState({ selectedConceptUID: this.props.modelConceptUID });
    }
  }

  selectConcept = e => {
    const { onSave, QuestionApi } = this.props;
    this.setState({ selectedConceptUID: e.value });

    // Auto-save when using callback mode (not QuestionApi mode)
    if (onSave && !QuestionApi) {
      onSave(e.value);
    }
  };

  handleSave = () => {
    const { dispatch, onSave, QuestionApi, loadQuestionAction, questionID } = this.props;
    const { selectedConceptUID } = this.state;

    if (QuestionApi && loadQuestionAction && dispatch) {
      // Use QuestionApi to update model concept
      QuestionApi.updateModelConcept(questionID, selectedConceptUID).then(() => {
        dispatch(loadQuestionAction(questionID));
        dispatch({ type: 'DISPLAY_MESSAGE', message: 'Model concept saved!' });
        window.history.back();
      }).catch((error) => {
        dispatch({ type: 'DISPLAY_ERROR', error: `Model concept update failed! ${error}` });
      });
    } else if (onSave) {
      onSave(selectedConceptUID);
    }
  };

  handleRemove = () => {
    const { dispatch, onRemove, QuestionApi, loadQuestionAction, questionID } = this.props;

    if (QuestionApi && loadQuestionAction && dispatch) {
      // Use QuestionApi to update model concept to null
      QuestionApi.updateModelConcept(questionID, null).then(() => {
        dispatch(loadQuestionAction(questionID));
        dispatch({ type: 'DISPLAY_MESSAGE', message: 'Model concept removed!' });
        window.history.back();
      }).catch((error) => {
        dispatch({ type: 'DISPLAY_ERROR', error: `Model concept removal failed! ${error}` });
      });
    } else if (onRemove) {
      onRemove();
    }
  };

  handleCancel = () => {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel();
    } else {
      window.history.back();
    }
  };

  renderButtons = () => {
    const { QuestionApi, onCancel } = this.props;
    const { selectedConceptUID } = this.state;
    const saveDisabled = selectedConceptUID === this.props.modelConceptUID;

    // Only show Save/Cancel buttons in actions mode (QuestionApi mode)
    // In callback mode, changes auto-save so no Save button is needed
    const showSaveButton = QuestionApi;
    const showCancelButton = QuestionApi || onCancel;

    return(
      <p className="control">
        {showSaveButton && (
          <button
            className="button is-primary"
            disabled={saveDisabled}
            onClick={this.handleSave}
            type="button"
          >
            Save Model Concept
          </button>
        )}
        {showCancelButton && (
          <button
            className="button is-outlined is-info"
            onClick={this.handleCancel}
            style={{marginLeft: 5}}
            type="button"
          >
            Cancel
          </button>
        )}
        <button
          className="button is-outlined is-danger"
          onClick={this.handleRemove}
          style={{marginLeft: 5}}
          type="button"
        >
          Remove
        </button>
      </p>
    )
  }

  renderLessonModelNote = () => {
    const { lessonModelConceptUID, concepts } = this.props;
    const { selectedConceptUID } = this.state;

    if (!lessonModelConceptUID || lessonModelConceptUID === selectedConceptUID || !concepts) {
      return null;
    }

    const conceptData = concepts.data || concepts;
    const conceptList = conceptData['0'] || conceptData;

    if (!conceptList) return null;

    const concept = conceptList.find(c => c.uid === lessonModelConceptUID);

    if (concept) {
      return (
        <div style={{ marginBottom: '10px' }}>
          <p>The activity that this question belongs to has the following Model Concept:</p>
          <p><i>"{concept.displayName}"</i></p>
        </div>
      )
    }
  }

  render() {
    const {
      conceptsFeedback,
      children
    } = this.props;
    const { selectedConceptUID } = this.state;

    let conceptFeedback;
    if (selectedConceptUID && conceptsFeedback) {
      conceptFeedback = conceptsFeedback.data ? conceptsFeedback.data[selectedConceptUID] : conceptsFeedback[selectedConceptUID];
    }

    return(
      <div className="box">
        <h4 className="title">Choose Model</h4>
        {this.renderLessonModelNote()}
        <div className="control">
          <ConceptSelector
            currentConceptUID={selectedConceptUID || ''}
            handleSelectorChange={this.selectConcept}
            onlyShowConceptsWithConceptFeedback
          />
          <ConceptExplanation {...conceptFeedback} />
          {children}
        </div>
        {this.renderButtons()}
      </div>
    )
  }
}

export { ChooseModelContainer }
